const MagGlassIcon = () => (
  <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
    <g id="icons/controls/search" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M7,11.75 C4.381,11.75 2.25,9.619 2.25,7 C2.25,4.381 4.381,2.25 7,2.25 C9.619,2.25 11.75,4.381 11.75,7 C11.75,9.619 9.619,11.75 7,11.75 M14.817,13.933 L11.66,10.776 C12.497,9.745 13,8.432 13,7 C13,3.687 10.313,1 7,1 C3.687,1 1,3.687 1,7 C1,10.313 3.687,13 7,13 C8.432,13 9.744,12.497 10.776,11.66 L13.933,14.817 C14.055,14.939 14.215,15 14.375,15 C14.535,15 14.695,14.939 14.817,14.817 C15.061,14.573 15.061,14.177 14.817,13.933"
        id="Fill-1"
        fill="#5A5A5A"
      />
    </g>
  </svg>
);

export default MagGlassIcon;
